/**
 * Takes a string and splits it on the capital letters
 * @param {string} The string to split
 * @returns {string} The formatted string
 */
export default function splitStringOnCapital(input: string): string {
  return input ? input.split(/(?=[A-Z])/).join(" ") : "";
}
